/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

//custom libraries
import { dateFormat } from "../helpers/dataFormat";

export default function ShowOrderComment(props: any) {
  const [showAllComments, setShowAllComments] = React.useState(false);
  const { orderComment } = props;
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <>
      <Grid item container direction="column" spacing={3}>
        <Grid
          item
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={2}>
          <Grid item>
            <Typography variant="h3">
              {showAllComments
                ? t("OrderManagement.AllComments")
                : t("OrderManagement.LatestComments")}
            </Typography>
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={!!showAllComments}
                  onChange={() => {
                    setShowAllComments(!showAllComments);
                  }}
                  name="switchToShow"
                  color="primary"
                />
              }
              label={t("OrderManagement.ShowAllComments")}
            />
          </Grid>
        </Grid>
        {!showAllComments && orderComment && orderComment.length > 0 && (
          <Grid item>
            <Typography variant="body2" gutterBottom>
              {`${dateFormat(
                locale,
                orderComment[0].commentDetails.lastupdate
              )} - by ${orderComment[0].serviceRepDetails.logonId}`}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {`${orderComment[0].commentDetails.comment}`}
            </Typography>
          </Grid>
        )}
        {showAllComments &&
          orderComment &&
          orderComment.length > 0 &&
          orderComment.map((e: any) => (
            <Grid key={e.commentDetails.lastupdate} item>
              <Typography variant="body2" gutterBottom>
                {`${dateFormat(locale, e.commentDetails.lastupdate)} - by ${
                  e.serviceRepDetails.logonId
                }`}
              </Typography>
              <Typography variant="body1" gutterBottom>
                {`${e.commentDetails.comment}`}
              </Typography>
            </Grid>
          ))}
      </Grid>
    </>
  );
}
